// @flow
import * as React from 'react';

type PageHeightAdjusterProps = {
    children: React.Node
};

type PageHeightAdjusterState = {
    adjustmentHeight: number
};

const findTetherElement = (node: Node) => {
    return node instanceof HTMLElement ? node.classList.contains('tether-element') : false;
};

export default
class PageHeightAdjuster extends React.Component<PageHeightAdjusterProps, PageHeightAdjusterState> {
    _mutationObserver = new MutationObserver((mutationsList) => {
        const mutation = mutationsList.find((mutation) => {
            if (mutation.addedNodes) {
                return Array.from(mutation.addedNodes.values()).some(findTetherElement);
            } else if (mutation.removedNodes) {
                return false;
            }

        });

        if (mutation && mutation.addedNodes) {
            const node = Array.from(mutation.addedNodes).find(findTetherElement);
            if (node instanceof HTMLElement) {
                const domRect = node.getBoundingClientRect();
                const listBottom = domRect.top + domRect.height;
                // $FlowIgnore
                const clientHeight = document.documentElement.clientHeight;
                const adjustmentHeight = -2 * (clientHeight - listBottom);

                this.setState({ adjustmentHeight });

                return;
            }

        }

        this.setState({ adjustmentHeight: 0 });
    });

    state = {
        adjustmentHeight: 0
    };

    componentDidMount() {
        // $FlowIgnore
        this._mutationObserver.observe(document.body, {childList: true});
    }

    componentWillUnmount() {
        this._mutationObserver.disconnect();
    }

    render() {
        if (this.state.adjustmentHeight > 0) {
            return (
                <React.Fragment>
                    <div style={{height: this.state.adjustmentHeight, flexShrink: 0}} />
                    {this.props.children}
                </React.Fragment>
            );
        }
        return this.props.children;
    }
}
